import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import utilRules from '@/libs/rules';
import settleAgreement from '../settleAgreement/index.vue'; //表单

var formData = {
  storeType: 1,
  //入驻类型
  businessLicenseImage: '',
  //营业执照照片：
  companyName: '',
  //公司名称
  unionCreditCode: '',
  //统一社会信用代码
  businessLicenseProvince: '',
  //营业执照所在地省份
  businessLicenseCity: '',
  //营业执照所在地城市
  businessLicenseDistrict: '',
  // 营业执照所在地区/县
  businessLicenseAddress: '',
  //营业执照住所
  setupDate: '',
  //成立日期
  businessDateFrom: '',
  //营业期限 开始日期
  businessDateTo: '',
  //营业期限 结束日期
  businessDateLongTime: true,
  //是否是长期营业期限
  registeredCapital: '',
  //注册资本
  businessScope: '',
  //经营范围
  legalPersonName: '',
  //法人姓名
  legalPersonIdCardNumber: '',
  //	法人身份证号码
  legalPersonIdCardFace: '',
  //法人身份证人像面照片
  legalPersonIdCardEmblem: '',
  //法人身份证国徽面照片
  legalPersonIdCardTimeFrom: '',
  //法人身份证有效期 开始日期
  legalPersonIdCardTimeTo: '',
  //法人身份证有效期 结束日期
  legalPersonIdCardLongTime: true,
  //法人身份证有效期是否是长期有效
  taxpayerType: 1,
  //纳税人类型
  taxpayerCertImage: '',
  //纳税人资格证
  //经营类目列表
  businessCategories: [],
  storeName: '',
  //店铺名称
  storeLogo: '',
  //店铺logo
  storeIntro: '',
  //店铺简介
  contractNo: '',
  //合同编号
  bankBranchName: '',
  //支行名称
  bankAccount: '',
  //账号
  bankName: '' //开户行

};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}).filter(function (v) {
  return !['legalPersonIdCardTimeFrom', 'businessDateFrom'].includes(v);
}));

export default {
  components: {
    settleAgreement: settleAgreement
  },
  data: function data() {
    var checkUnionCreditCode = function checkUnionCreditCode(rule, value, callback) {
      if (!value) {
        return callback(new Error('统一社会信用代码不能为空'));
      } else {
        var reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;

        if (!reg.test(value)) {
          callback(new Error('请输入正确的统一社会信用代码'));
        } else {
          callback();
        }
      }
    };

    return {
      dialogFormVisible: false,
      rules: _objectSpread(_objectSpread({}, utilRules(rulelist)), {}, {
        unionCreditCode: [{
          required: true,
          trigger: 'blur',
          validator: checkUnionCreditCode
        }]
      }),
      formData: formData,
      uploadData: {
        data: {
          token: '',
          key: ''
        },
        accept: '.png,.jpeg,.jpg,.jpg',
        class: 'avatar-uploader d2-mr',
        action: 'https://up-z2.qiniup.com',
        'show-file-list': false,
        multiple: false
      },
      radioBlock: false,
      //协议
      cascaderProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        label: 'typeName',
        value: 'goodsTypeId',
        leaf: 'leaf'
      },
      goodsTypesList: [],
      businessCategories: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$_this$$api$get, token, _data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api.getUploadToken();

            case 2:
              _yield$_this$$api$get = _context.sent;
              token = _yield$_this$$api$get.token;
              _this.uploadData.data.token = token;

              if (!_this.$route.query.id) {
                _context.next = 10;
                break;
              }

              _context.next = 8;
              return _this.$api.information();

            case 8:
              _data = _context.sent;
              _this.formData = Object.assign(_this.formData, _data);

            case 10:
              _this.getGoodsTypes({
                typeLevel: 1
              }, function () {});

              _this.formData = Object.assign(_this.formData, data);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    selectChange: function selectChange(e) {
      var _this2 = this;

      this.formData.businessCategories = [];
      var lis = this.goodsTypesList.filter(function (v) {
        return e.includes(v.goodsTypeId);
      });
      lis.forEach(function (v) {
        var params = {
          goodsTypeId: v.goodsTypeId,
          goodsTypeName: v.typeName,
          items: [],
          allSelected: true
        };

        _this2.formData.businessCategories.push(params);
      });
    },
    // async longTime(e, key) {
    //   let arr = cloneDeep(rulelist)
    //   if (e) {
    //     this.rules = utilRules(arr.filter(v => v !== key))
    //   } else {
    //     arr.push(key)
    //     this.rules = utilRules(arr)
    //   }
    //   await YL.sleep(0)
    //   this.$refs.loginForm.clearValidate()
    // },
    businessDel: function businessDel($index, row) {
      var i = this.businessCategories.findIndex(function (v) {
        return v == row.goodsTypeId;
      });
      this.businessCategories.splice(i, 1);
      this.formData.businessCategories.splice($index, 1);
    },
    hideCascader: function hideCascader() {// const res = this.$refs.cascader.getCheckedNodes()
      // if (!res.length || res[0].path.length !== 3) return
      // this.cascaderBlur(res[0].path)
      // this.$refs.cascader.clearCheckedNodes()
    },
    flatFn: function flatFn(arr) {
      var zIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return arr.map(function (v) {
        return v.goodsTypeName;
      }).join(',');
    },
    lazyLoad: function lazyLoad(node, resolve) {
      var level = node.level,
          data = node.data;
      var obj = {
        typeLevel: level + 1,
        preTypeId: data === null || data === void 0 ? void 0 : data.goodsTypeId
      };
      this.getGoodsTypes(obj, resolve);
    },
    //获取类目
    getGoodsTypes: function getGoodsTypes(data, resolve) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, o;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$api.goodsTypes(_objectSpread({
                  pageNo: 1,
                  pageSize: 99
                }, data));

              case 2:
                res = _context2.sent;
                o = res.records;

                if (data.typeLevel == 3) {
                  o.unshift({
                    typeName: '全部',
                    goodsTypeId: '0',
                    allSelected: true,
                    leaf: true,
                    typeLevel: 3
                  });
                }

                _this3.goodsTypesList = _this3.goodsTypesList.concat(o);
                resolve(o);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    cascaderBlur: function cascaderBlur(e) {
      var _this4 = this;

      var n = {};
      e.forEach(function (v) {
        n = _objectSpread(_objectSpread({}, n), _this4.fileObj(v));
      });
      this.formData.businessCategories.push(n);
      var busLs = this.reduceSet(this.formData.businessCategories);
      this.formData.businessCategories = busLs;
    },
    //过滤添加
    fileObj: function fileObj(key) {
      var data = {
        items: []
      };
      var item = this.goodsTypesList.find(function (v) {
        return v.goodsTypeId == key;
      });
      return item.typeName;

      if (item) {
        var typeLevel = item.typeLevel;

        if (typeLevel == 1) {
          data['goodsTypeId'] = item.goodsTypeId;
          data['goodsTypeName'] = item.typeName;
        } else if (typeLevel == 2) {
          data['goodsTypeIdSecond'] = item.goodsTypeId;
          data['goodsTypeNameSecond'] = item.typeName;
        } else if (typeLevel == 3 && item.goodsTypeId !== '0') {
          data['items'].push({
            goodsTypeId: item.goodsTypeId,
            goodsTypeName: item.typeName
          });
        } else {
          data['allSelected'] = true;
          data['items'].push({
            goodsTypeId: item.goodsTypeId,
            goodsTypeName: item.typeName
          });
        }
      }

      return data;
    },
    //去重
    reduceSet: function reduceSet(arr) {
      var o = {};
      return arr.reduce(function (cur, next) {
        o[next.items[0].goodsTypeId] ? '' : o[next.items[0].goodsTypeId] = true && cur.push(next);
        return cur;
      }, []);
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['loginForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.formData, 'businessLicenseProvince', e[0]);
      e[1] && this.$set(this.formData, 'businessLicenseCity', e[1]);
      e[2] && this.$set(this.formData, 'businessLicenseDistrict', e[2]);
    },
    // 提交表单信息
    submit: function submit() {
      var _this5 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid, obj) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  if (_this5.radioBlock) {
                    _context3.next = 4;
                    break;
                  }

                  return _context3.abrupt("return", YL.message('请先阅读并同意《要炼入驻协议》', 'error'));

                case 4:
                  _context3.next = 6;
                  return _this5.$api.apply(_this5.formData);

                case 6:
                  _context3.next = 8;
                  return YL.message('提交入驻申请,等待管理员审核');

                case 8:
                  _context3.next = 10;
                  return YL.isStoreAuto(1);

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    businessDateLongTime: function businessDateLongTime(val) {
      if (val) {
        this.formData.businessDateFrom = '';
        this.formData.businessDateTo = '';
      }
    },
    businessDateFrom: function businessDateFrom(val) {
      if (val) {
        this.formData.businessDateLongTime = false;
      }
    },
    legalPersonIdCardLongTime: function legalPersonIdCardLongTime(val) {
      if (val) {
        this.formData.legalPersonIdCardTimeFrom = '';
        this.formData.legalPersonIdCardTimeTo = '';
      }
    },
    legalPersonIdCardTimeFrom: function legalPersonIdCardTimeFrom(val) {
      if (val) {
        this.formData.legalPersonIdCardLongTime = false;
      }
    }
  }
};